<template>
  <div>
    <ckManage />
  </div>
</template>

<script>
// 获取接口地址
import ckManage from '@/components/Warehouse/ckManage'
export default {
  name: 'Ckgl',
  components: {
    // sideMenu,
    // Header,
    ckManage
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
